import React, { useEffect, useState } from "react";
import "./GlobalMarketData.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function GlobalMarketData() {

    // WebSocket connection
    const { globalMarketData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [globalDataList, setGlobalDataList] = useState([]);
    const [commodityDataList, setCommodityDataList] = useState([]);
    const [currencyDataList, setCurrencyDataList] = useState([]);
    const [indianAdrDataList, setIndianAdrDataList] = useState([]);
    const [activeTab, setActiveTab] = useState("GLOBAL_DATA");

    /* ============================================== */

    useEffect(() => {
        console.log("Incoming Global Data:", globalMarketData);

        if (globalMarketData && typeof globalMarketData === "object") {

            if (globalMarketData.GLOBAL_INDICIES) {
                setGlobalDataList(globalMarketData.GLOBAL_INDICIES);
            }

            if (globalMarketData.COMMODITIES) {
                setCommodityDataList(globalMarketData.COMMODITIES);
            }

            if (globalMarketData.CURRENCIES) {
                setCurrencyDataList(globalMarketData.CURRENCIES);
            }

            if (globalMarketData.INDIAN_ADR) {
                setIndianAdrDataList(globalMarketData.INDIAN_ADR);
            }

            console.log("✅ Processed globalDataList:", globalDataList);
            console.log("✅ Processed commodityDataList:", commodityDataList);
            console.log("✅ Processed currencyDataList:", currencyDataList);
            console.log("✅ Processed indianAdrDataList:", indianAdrDataList);
        }

    }, [globalMarketData]);
    // Header Data
    const headerSource = globalDataList?.[0]; // Assuming header info is in the first item of the first section
    const headerData = [
        {
            label1: "Date",
            value1: headerSource?.localDate ?? "--",
            label2: "Time",
            value2: headerSource?.localTime ?? "--",
        },
    ];

    const getRatingClass = (rating) => {
        switch (rating) {
            case "Very Bullish":
            case "Bullish":
                return "text-success fw-bold"; // green

            case "Very Bearish":
            case "Bearish":
                return "text-danger fw-bold"; // red
            case "Neutral":
                return "text-dark fw-bold"; // black

            default:
                return "";
        }
    };

    return (
        <div className="global-market-data">

            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">
                    <div className="left-nav header-flex">
                        <div className="logo-container">
                            <img src="/assets/images/noptionwave-logo-1.png" className="header-logo" alt="logo" />
                        </div>

                        {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                <span className="header-line">{item.label1} : {item.value1}</span>
                                <span className="header-line">{item.label2} : {item.value2}</span>
                            </div>
                        ))}
                    </div>
                </nav>
            </header>

            <div className="tab-container">
                <div className="tab">

                    <button className={`tablinks sub-header-font ${activeTab === "GLOBAL_DATA" ? "active" : ""}`}
                        onClick={() => setActiveTab("GLOBAL_DATA")}  >
                        GLOBAL DATA
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "INDIAN_ADR" ? "active" : ""}`}
                        onClick={() => setActiveTab("INDIAN_ADR")} >
                        INDIAN ADR
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "COMMODITIES" ? "active" : ""}`}
                        onClick={() => setActiveTab("COMMODITIES")} >
                        COMMODITIES
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "CURRENCIES" ? "active" : ""}`}
                        onClick={() => setActiveTab("CURRENCIES")}  >
                        CURRENCIES
                    </button>

                </div>
            </div>

            {/* ================= GRID ================= */}

            {/* ===== GLOBAL INDICES ===== */}
            {activeTab === "GLOBAL_DATA" && (
                <div className="volume-table-container">
                    <table className="responsive-table responsive-table-volume table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>LTP</th>
                                <th>CHANGE</th>
                                <th>CHG(%)</th>
                                <th>HIGH</th>
                                <th>LOW</th>
                                <th>OPEN</th>
                                <th>PREV CLOSE</th>
                                <th>52W HIGH</th>
                                <th>52W LOW</th>
                                <th>TECHNICAL RATING</th>
                            </tr>
                        </thead>

                        <tbody>
                            {globalDataList?.length > 0 ? (
                                globalDataList.map((section, sIdx) => (
                                    <React.Fragment key={sIdx}>

                                        {/* ✅ HEADING ROW */}
                                        <tr className="">
                                            <td colSpan="11" className="table-heading text-start fw-bold">
                                                {section.heading?.replace("_", " ")}
                                            </td>
                                        </tr>

                                        {/* ✅ DATA ROWS */}
                                        {section.globalIndiciesDataModelList?.length > 0 ? (
                                            section.globalIndiciesDataModelList.map((row, idx) => (
                                                <tr key={`${sIdx}-${idx}`}>
                                                    <td className="fw-bold">{row.name}</td>
                                                    <td>{row.price}</td>

                                                    <td className={row.netChange >= 0 ? "text-success" : "text-danger"}>
                                                        {row.netChange}
                                                    </td>

                                                    <td className={row.percentChange >= 0 ? "text-success" : "text-danger"}>
                                                        {row.percentChange}
                                                    </td>

                                                    <td>{row.high}</td>
                                                    <td>{row.low}</td>
                                                    <td>{row.open}</td>
                                                    <td>{row.prevClose}</td>
                                                    <td>{row.wk52High}</td>
                                                    <td>{row.wk52Low}</td>
                                                    <td className={getRatingClass(row.technicalRating)}>
                                                        {row.technicalRating}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="11" className="text-center">
                                                    No data available for {section.heading}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="11">copyrights © 2026 | noptionwave</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== INDIAN ADR ===== */}
            {activeTab === "INDIAN_ADR" && (
                <div className="volume-table-container">
                    <table className="responsive-table responsive-table-volume table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>LTP</th>
                                <th>CHANGE</th>
                                <th>CHG(%)</th>
                                <th>HIGH</th>
                                <th>LOW</th>
                                <th>OPEN</th>
                                <th>PREV CLOSE</th>
                                <th>UPDATED AT</th>
                            </tr>
                        </thead>

                        <tbody>
                            {indianAdrDataList?.length > 0 ? (
                                indianAdrDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="fw-bold">{row.shortname}</td>
                                        <td>{row.lastprice}</td>

                                        <td className={row.change >= 0 ? "text-success" : "text-danger"}>
                                            {row.change}
                                        </td>

                                        <td className={row.percentchange >= 0 ? "text-success" : "text-danger"}>
                                            {row.percentchange}
                                        </td>

                                        <td>{row.high}</td>
                                        <td>{row.low}</td>
                                        <td>{row.open}</td>
                                        <td>{row.prev_close}</td>
                                        <td>{row.updated_at}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="9">copyrights © 2026 | noptionwave</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== COMMODITIES ===== */}
            {activeTab === "COMMODITIES" && (
                <div className="volume-table-container">
                    <table className="responsive-table responsive-table-volume table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>LTP</th>
                                <th>CHANGE</th>
                                <th>CHG(%)</th>
                                <th>HIGH</th>
                                <th>LOW</th>
                                <th>OPEN</th>
                                <th>PREV CLOSE</th>
                                <th>52W HIGH</th>
                                <th>52W LOW</th>
                                <th>TECHNICAL RATING</th>
                            </tr>
                        </thead>

                        <tbody>
                            {commodityDataList?.length > 0 ? (
                                commodityDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="fw-bold">{row.name}</td>
                                        <td>{row.price}</td>

                                        <td className={row.netChange >= 0 ? "text-success" : "text-danger"}>
                                            {row.netChange}
                                        </td>

                                        <td className={row.percentChange >= 0 ? "text-success" : "text-danger"}>
                                            {row.percentChange}
                                        </td>

                                        <td>{row.high}</td>
                                        <td>{row.low}</td>
                                        <td>{row.open}</td>
                                        <td>{row.prevClose}</td>
                                        <td>{row.wk52High}</td>
                                        <td>{row.wk52Low}</td>

                                        <td className={getRatingClass(row.technicalRating)}>
                                            {row.technicalRating}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="11">copyrights © 2026 | noptionwave</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== CURRENCIES ===== */}
            {activeTab === "CURRENCIES" && (
                <div className="volume-table-container">
                    <table className="responsive-table responsive-table-volume table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>LTP</th>
                                <th>CHANGE</th>
                                <th>CHG(%)</th>
                                <th>HIGH</th>
                                <th>LOW</th>
                                <th>OPEN</th>
                                <th>PREV CLOSE</th>

                            </tr>
                        </thead>

                        <tbody>
                            {currencyDataList?.length > 0 ? (
                                currencyDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="fw-bold">{row.name}</td>
                                        <td>{row.ltp}</td>

                                        <td className={row.chg >= 0 ? "text-success" : "text-danger"}>
                                            {row.chg}
                                        </td>

                                        <td className={row.chgper >= 0 ? "text-success" : "text-danger"}>
                                            {row.chgper}
                                        </td>

                                        <td>{row.high}</td>
                                        <td>{row.low}</td>
                                        <td>{row.open}</td>
                                        <td>{row.prevclose}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="8">copyrights © 2026 | noptionwave</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}


        </div>
    );
}